import { SetStateAction, Dispatch } from "react";
import {
  Box,
  Button,
  SxProps,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Storehouse, StorehouseSupplierOptionsWithBlank, Supplier } from "../types";
import { IncrementalSearchElement } from "./Common";

const incrementalSearchOptionLength = 10;

type Props = {
  open: boolean;
  onClose: Function;
  onSearch: Function;
  storehouse: string;
  supplier: string;
  storehouseOptions: Storehouse[];
  supplierOptions: Supplier[];
  setStorehouseSupplier: Dispatch<SetStateAction<StorehouseSupplierOptionsWithBlank>>;
  setStorehouse: Dispatch<SetStateAction<string>>;
  setSupplier: Dispatch<SetStateAction<string>>;
};

const styles: { [key: string]: SxProps } = {
  searchRowBox: {
    minWidth: 450,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
};

/**
 * 在庫更新の対象仕入先/倉庫選択コンポーネント
 * @param root0 コンポーネントのprops
 * @returns JSX.Element
 */
export default function PlaceSelectDialog({
  open,
  onClose,
  onSearch,
  storehouse,
  supplier,
  storehouseOptions,
  supplierOptions,
  setStorehouseSupplier,
  setStorehouse,
  setSupplier,
}: Props) {
  const handleStorehouseChange = (
    value: string | null,
    options: Storehouse[],
    setSh: Dispatch<SetStateAction<string>>,
    setSup: Dispatch<SetStateAction<string>>,
    setShSup: Dispatch<SetStateAction<StorehouseSupplierOptionsWithBlank>>,
  ) => {
    if (value) {
      setSh(options.filter((sh) => sh.name === value)[0].name);
      setSup("");
      setShSup("倉庫");
    } else {
      setSh("");
      setShSup("");
    }
  };
  const handleSupplierChange = (
    value: string | null,
    setSh: Dispatch<SetStateAction<string>>,
    setSup: Dispatch<SetStateAction<string>>,
    setShSup: Dispatch<SetStateAction<StorehouseSupplierOptionsWithBlank>>,
  ) => {
    if (value) {
      setSup(value);
      setSh("");
      setShSup("仕入先");
    } else {
      setSup("");
      setShSup("");
    }
  };
  const supplierStorehouseComponent = () => (
    <>
      <Box sx={styles.searchRowBox}>
        <IncrementalSearchElement
          label="倉庫名"
          options={storehouseOptions.map((sh) => sh.name)}
          value={storehouse}
          onChange={(val: string) =>
            handleStorehouseChange(
              val,
              storehouseOptions,
              setStorehouse,
              setSupplier,
              setStorehouseSupplier,
            )
          }
          optionLength={incrementalSearchOptionLength}
        />
        <IncrementalSearchElement
          label="仕入先名"
          options={supplierOptions.map((so) => so.supplierName)}
          value={supplier}
          onChange={(val: string) =>
            handleSupplierChange(val, setStorehouse, setSupplier, setStorehouseSupplier)
          }
          optionLength={incrementalSearchOptionLength}
        />
      </Box>
      {/* <Box sx={styles.searchRowBox}>
        <Box p={1}>
          <CustomTextField
            id="supplier-text"
            type="text"
            label="倉庫絞込"
            text={storehouseFilter}
            setText={(val) => setStorehouseFilter(val)}
            maxLength={100}
            variant="outlined"
            size="small"
          />
        </Box>
        <SelectForm id="storehouse" label="倉庫" required={required} optionList={storehouseOptions.map(sh => sh.name)} value={storehouse} setValue={(val) => {
          setStorehouse(val);
          setStorehouseSupplier(storehouseSupplierOptions[0]);
          setSupplier('');
        }} />
      </Box>
      <Box sx={styles.searchRowBox}>
        <Box p={1}>
          <CustomTextField
            id="supplier-text"
            type="text"
            label="仕入先絞込"
            text={supplierFilter}
            setText={(val) => setSupplierFilter(val)}
            maxLength={100}
            variant="outlined"
            size="small"
          />
        </Box>
        <SelectForm id="supplier" label="仕入先名" required={required} optionList={supplierOptions} value={supplier} setValue={(val) => {
          setSupplier(val);
          setStorehouseSupplier(storehouseSupplierOptions[1]);
          setStorehouse('')
        }} />
      </Box> */}
    </>
  );

  return (
    <Dialog open={open} onClose={() => onClose()}>
      <Box p={2}>
        <DialogTitle>更新対象を選択してください</DialogTitle>
        <DialogContent>{supplierStorehouseComponent()}</DialogContent>
        <DialogActions>
          <Button variant="custom-outlined" onClick={() => onClose()}>
            キャンセル
          </Button>
          <Button variant="contained" onClick={() => onSearch()}>
            更新画面へ
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
